// @flow
/* eslint-disable sort-keys, max-len */
export default {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Inloggen om te Bieden',
                signup: 'Aanmelden om te bieden',
                register_long: 'Registreer voor Veiling',
                pending: 'Registratie is in Behandling',
                declined: 'Registratie is Geweigerd',
                closed: 'Kavel Gesloten',
                sent: 'Uw bod is verzonden',
                outbid: 'U bent Overboden, Biedt {amount}',
                bid: 'Bied {amount}',
                winning: 'U bent aan het Winnen',
            },
            conversions: {
                lot_number: 'Kavel {lotNumber}',
            },
            description: {
                estimate_range: 'Geschat {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
            },
            messages: {
                competing_bid_amount: '{amount}: Concurrerend Bod',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    'Concurrerende Bieder werd door het bod van Bieder {paddleNumber} bij Afwezigheid Overboden',
                last_bid_retracted: 'Laatste bod van {amount} is ingetrokken',
                liveauctioneers_bid_amount: '{amount}: LiveAuctioneers Bieder {paddleNumber}',
                liveauctioneers_bid_amount_absentee:
                    '{amount}: LiveAuctioneers Bieder {paddleNumber} bod bij Afwezigheid',
                lot_number_passed: 'Kavel {lotNumber} Gepasseerd',
                lot_number_reopened: 'Kavel {lotNumber} Opnieuw Geopend',
                lot_number_skipped: 'Kavel {lotNumber} Overgeslagen',
                lot_number_unsold: 'Kavel {lotNumber} Niet Verkocht',
                lot_opened_asking: 'Kavel {lotNumber} Geopend – Vraag {amount}',
                lot_sold_competing_bidder: 'Kavel {lotNumber} verkocht voor {amount} aan Concurrerende Bieder',
                lot_sold_liveauctioneers_bidder: 'Kavel {lotNumber} verkocht voor {amount} aan Bieder {paddleNumber}',
                my_bid_amount: '{amount}: Mijn Bod',
                my_bid_amount_absentee: '{amount}: Mijn Bod bij Afwezigheid',
                my_bid_retracted: 'Uw bod voor {amount} werd ingetrokken',
                registration_approved: 'Uw registratie is goedgekeurd',
                reserve_not_met: 'Reserve is niet behaald',
                you_been_outbid_by_liveauctioneers_absentee:
                    'U bent door het bod van Bieder {paddleNumber} bij Afwezigheid Overboden',
                you_ve_won_lot: 'Je hebt Kavel {lotNumber} gewonnen',
            },
            missives: {
                fair_warning_lot_about_to_close: 'Waarschuwing... Deze kavel gaat bijna sluiten',
                going_once_going_twice: 'EENMAAL... ANDERMAAL...',
                third_and_final_warning: 'DERDE EN LAATSTE WAARSCHUWING...',
            },
            status: {
                remaining: '{remaining} van de {total} Kavels Resterend',
            },
            thumbnail_scroller: {
                next: 'Volgende Kavels',
            },
        },
    },
};
